import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { LlttfInvitationFormComponent } from 'src/app/components/invitations/llttf-invitations/llttf-invitation-form/llttf-invitation-form.component';
import { LLTTFInvitations, LLTTFInvitationsDefaultValue } from 'src/app/components/invitations/llttf-invitations/llttf-invitations';
import { LlttfInvitationService } from 'src/app/services/llttf-invitation.service';
import { ToastService } from 'src/app/services/toast-service.service';

@Component({
    selector: 'app-create-llttf-invite',
    templateUrl: './create-llttf-invite.component.html',
    styleUrls: ['./create-llttf-invite.component.scss'],
    standalone: false
})
export class CreateLlttfInviteComponent {
  llttfinvitation: LLTTFInvitations = LLTTFInvitationsDefaultValue();
  @ViewChild(LlttfInvitationFormComponent) llttfinvitationForm!:LlttfInvitationFormComponent;
  isSubmitted=false;
  hideForm=false;
  invitationLink:string='';
  topmsg:string='<strong>Cohort created </strong>- Copy the invite link below to send to cohort participants.'
  pageName = CheckPageAccess.ADDLLTTFINVITATION
  constructor(private _llttfinviteservice: LlttfInvitationService, private _toastservice: ToastService, private router: Router) { }

  onSubmit() {
    this.isSubmitted=true;
    if(!this.llttfinvitationForm.validateReqFileds())
    {
      this._toastservice.showErrorMessage('Please correct all the errors first.')
      return;
    }
    this._llttfinviteservice.createllttfinvitation(this.llttfinvitation).subscribe({
      next: (response) => {
        if (response.status) {
          this._toastservice.showMessage("Invitation created successfully");
          this.hideForm = true;
          this.invitationLink = response.message;
          this.topmsg = "<strong>Cohort created </strong>- Copy the invite link below to send to cohort participants.";
        }
        else {
          this._toastservice.showErrorMessage(response.message)
        }
      }
    })
  }
}
